/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PurchaseOrderStatus = {
    Cleared: 'CLEARED',
    RemainingBudget: 'REMAINING_BUDGET',
    EstimationOverrun: 'ESTIMATION_OVERRUN',
    InvoicedOverrun: 'INVOICED_OVERRUN'
} as const;
export type PurchaseOrderStatus = typeof PurchaseOrderStatus[keyof typeof PurchaseOrderStatus];


export function instanceOfPurchaseOrderStatus(value: any): boolean {
    for (const key in PurchaseOrderStatus) {
        if (Object.prototype.hasOwnProperty.call(PurchaseOrderStatus, key)) {
            // @ts-ignore
            if (PurchaseOrderStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PurchaseOrderStatusFromJSON(json: any): PurchaseOrderStatus {
    return PurchaseOrderStatusFromJSONTyped(json, false);
}

export function PurchaseOrderStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseOrderStatus {
    return json as PurchaseOrderStatus;
}

export function PurchaseOrderStatusToJSON(value?: PurchaseOrderStatus | null): any {
    return value as any;
}

